import { Stack, Table, TableHeader, TableProvider, useTableState } from '@optimus-web/core';
import { OnboardingAuditField } from '@mews-commander/data-access';
import { getColumns } from './columns';

interface GoLiveTaskTableProps {
    audits: Array<OnboardingAuditField>;
    inDialog?: boolean;
    title?: React.ReactNode;
}

export const GoLiveTaskTable = ({ inDialog, audits, title }: GoLiveTaskTableProps) => {
    const [tableState, setTableState] = useTableState<OnboardingAuditField>({
        pagination: { show: false },
        grouping: ['area'],
    });

    return (
        <TableProvider columns={getColumns(inDialog)} state={tableState} onStateChange={setTableState}>
            <Stack vertical>
                {title ? <TableHeader title={title} /> : null}
                <Table data={audits} amountOfRows={audits.length} uniqueRowId="fieldIdentifier" fixedFirstColumn />
            </Stack>
        </TableProvider>
    );
};
